"use client";

/* eslint-disable @next/next/no-img-element */
import React from "react";
import Image from "next/image";
import { StyledWidgetHero } from "./widgetTemplates.styles";
import { IPlatform, IPlugin, ITemplate, ITemplateTag, IDBTemplateTag } from "../../types";
import { WidgetNavbar } from "../widgetNavbar/widgetNavbar.comp";
// import { CustomLink } from "../link/link.comp";
// import { FaPlus } from "@react-icons/all-files/fa/FaPlus";
import { Header } from "../header/header.comp";
// import { createMobileAwareClickHandler } from "../../helpers/mobile-redirect";
import { WidgetExamplesSection } from "../WidgetExamplesSection/WidgetExamplesSection.comp";
import { CustomLink } from "../link/link.comp";

interface IWidgetTemplatesProps {
  widget: IPlugin;
  templates: ITemplate[];
  platform?: IPlatform;
  allWidgets: IPlugin[];
  templateTags?: IDBTemplateTag[];
  showTemplatesTab?: boolean;
}

export const WidgetTemplates = ({
  widget,
  platform,
  templates,
  allWidgets,
  templateTags = [],
  showTemplatesTab,
}: IWidgetTemplatesProps) => {
  const name = `${widget.name} Templates${
    platform?.title ? ` for ${platform.title}` : ""
  }`;

  // Get unique tag slugs from templates
  const templateTagSlugs = templates
    .map((template: ITemplate) => template.tags)
    .flat()
    .filter((tag: string | undefined) => tag !== undefined);
  const uniqueTagSlugs = new Set(templateTagSlugs);

  // Map DB tags to ITemplateTag format, filtering only those used in templates
  const tagsData: ITemplateTag[] = templateTags
    .filter((dbTag) => uniqueTagSlugs.has(dbTag.slug))
    .map((dbTag) => ({
      _id: dbTag.slug,
      title: dbTag.name,
    }));

  return (
    <>
      <StyledWidgetHero>
        <Header fixedPosition={true} lightMode />
        <div className="navbar-wrapper">
          <WidgetNavbar
            widget={widget}
            platform={platform}
            showLogo
            showTemplatesTab={showTemplatesTab}
          />
        </div>
        <div className="hero-wrapper">
          <Image
            src="https://website-assets.commoninja.com/distribution/generic-bg.webp"
            alt="widget-editor"
            width={930}
            height={523}
            className="widget-editor-img"
          />
          <div className="hero-text-wrapper">
            {platform?.icon && (
              <div className="platform-img-wrapper">
                <Image src={platform.icon} alt={platform.title} fill />
              </div>
            )}
            <h1>{name}</h1>
            <h2>
              Check out our {widget.name} templates and discover the full
              potential of the widget!
            </h2>
          </div>
        </div>
        {(templates || []).length > 0 ? (
          <>
            <WidgetExamplesSection
              allWidgets={allWidgets}
              templatesData={{
                tags: tagsData,
                templates: templates || [],
              }}
              tagsMode="filter"
            />
          </>
        ) : (
          <div className="no-templates-wrapper">
            <p>
              <strong>
                We haven&apos;t created any templates for this widget yet.
              </strong>
            </p>
            <p>
              Check back later for new templates or start with a blank template.
              If you&apos;re interested in creating a template for this widget,
              please contact us.
            </p>
            <div className="start-with-blank-wrapper">
              <CustomLink
                target="_blank"
                href={`https://www.commoninja.com/${widget.slug}/editor`}
                variant="primary"
              >
                Start with blank
              </CustomLink>
            </div>
          </div>
        )}
        {/* {(templates || []).length > 0 && (
          <section className="templates-section">
            <div className="templates-content-wrapper">
              {templates.map((template) => renderTemplate(template))}
              <div className="template">
                <div className="browser">
                  <div className="top">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                  {renderBox(
                    undefined,
                    <div className="add-template">
                      <FaPlus size={40} className="icon" />
                    </div>
                  )}
                </div>
                <CustomLink
                  target="_blank"
                  href={`https://www.commonninja.com/${widget.slug}/editor`}
                  onClick={createMobileAwareClickHandler(
                    undefined,
                    `https://www.commoninja.com/${widget.slug}/editor`
                  )}
                >
                  Start with blank
                </CustomLink>
              </div>
            </div>
          </section>
        )} */}
      </StyledWidgetHero>
    </>
  );
};
